import { ReactNode } from 'react';
import { PromotionCard, PromotionCardProps } from '../../components/Cards';
import styles from './DashboardGrid.module.css';
import type { DashboardSlot, DashboardUserSummary } from '@practium/features/dashboard';
import { StatItemConfig, StatsGrid, UserSummary } from '@practium/features/dashboard';

export interface DashboardGridProps {
	userSummary?: DashboardUserSummary;
	stats: StatItemConfig[];
	promotion?: PromotionCardProps;
	slots: DashboardSlot[];
	renderSlot: (slot: DashboardSlot) => ReactNode;
}

export const DashboardGrid = ({ userSummary, stats, promotion, slots, renderSlot }: DashboardGridProps) => {
	const shouldShowPromotionWithSummary = Boolean(userSummary && promotion);
	const statsPromotion = shouldShowPromotionWithSummary ? undefined : promotion;
	const shouldBalanceOneThirdSlots =
		slots.length > 3 && slots.every((slot) => slot.size === 'oneThird') && slots.length % 3 === 1;

	return (
		<div className={styles.dashboard}>
			{userSummary && (
				<div className={styles.summaryRow}>
					<div className={styles.summaryMain}>
						<UserSummary user={userSummary} />
					</div>

					{promotion && (
						<div className={styles.summaryAction}>
							<PromotionCard
								title={promotion.title}
								subtitle={promotion.subtitle}
								buttonText={promotion.buttonText}
								onButtonClick={promotion.onButtonClick}
							/>
						</div>
					)}
				</div>
			)}

			<StatsGrid stats={stats} promotion={statsPromotion} />

			<div
				className={`${styles.dashboardGrid} ${
					shouldBalanceOneThirdSlots ? styles.dashboardGridBalanced : ''
				}`}
			>
				{slots.map((slot, index) => {
					const slotKey = `${slot.type}-${index}`;

					return (
						<div
							key={slotKey}
							className={slot.size === 'twoThirds' ? styles.slotTwoThirds : styles.slotOneThird}
						>
							{renderSlot(slot)}
						</div>
					);
				})}
			</div>
		</div>
	);
};
